(function () {
  function initPopup(root) {
    if (!root || root.dataset.ppInitialized) return;
    root.dataset.ppInitialized = 'true';

    var cookieName = root.dataset.cookieName;
    var frequency = root.dataset.frequency; // every_load | session | days | once
    var freqDays = parseInt(root.dataset.freqDays, 10) || 7;
    var trigger = root.dataset.trigger; // immediate | delay | scroll | exit_intent
    var delaySeconds = parseInt(root.dataset.delay, 10) || 0;
    var scrollPercent = parseInt(root.dataset.scroll, 10) || 0;
    var pages = root.dataset.pages; // all | index | product | collection | custom
    var customHandles = (root.dataset.customPages || '')
      .split(',')
      .map(function (h) { return h.trim().toLowerCase(); })
      .filter(Boolean);
    var enableDesktop = root.dataset.desktop === 'true';
    var enableMobile = root.dataset.mobile === 'true';

    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isMobile && !enableMobile) return;
    if (!isMobile && !enableDesktop) return;

    if (!pageMatches(pages, customHandles)) return;
    if (!frequencyAllows(frequency, freqDays, cookieName)) return;

    var opened = false;
    function open() {
      if (opened) return;
      opened = true;
      root.style.display = 'flex';
      requestAnimationFrame(function () {
        root.classList.add('pp-is-visible');
      });
      document.documentElement.style.overflow = 'hidden';
      markSeen(frequency, freqDays, cookieName);
      loadKlaviyoForm(root);
    }

    function close() {
      root.classList.remove('pp-is-visible');
      root.style.display = 'none';
      document.documentElement.style.overflow = '';
    }

    root.querySelectorAll('[data-popup-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    root.addEventListener('click', function (e) {
      if (e.target === root) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    if (trigger === 'immediate') {
      open();
    } else if (trigger === 'delay') {
      setTimeout(open, delaySeconds * 1000);
    } else if (trigger === 'scroll') {
      var handler = function () {
        var scrolled = window.scrollY || document.documentElement.scrollTop;
        var height = document.documentElement.scrollHeight - window.innerHeight;
        var pct = height > 0 ? (scrolled / height) * 100 : 0;
        if (pct >= scrollPercent) {
          open();
          window.removeEventListener('scroll', handler);
        }
      };
      window.addEventListener('scroll', handler, { passive: true });
    } else if (trigger === 'exit_intent') {
      if (isMobile) {
        // Mobile: fire on fast upward scroll near top as an exit-intent proxy
        var lastY = window.scrollY;
        var mHandler = function () {
          var y = window.scrollY;
          if (y < lastY - 40 && y < 300) {
            open();
            window.removeEventListener('scroll', mHandler);
          }
          lastY = y;
        };
        window.addEventListener('scroll', mHandler, { passive: true });
      } else {
        var eHandler = function (e) {
          if (e.clientY <= 0) {
            open();
            document.removeEventListener('mouseleave', eHandler);
          }
        };
        document.addEventListener('mouseleave', eHandler);
      }
    }
  }

  function pageMatches(pages, customHandles) {
    if (!pages || pages === 'all') return true;
    var body = document.body;
    if (pages === 'index') return body.classList.contains('template-index');
    if (pages === 'product') return body.classList.contains('template-product');
    if (pages === 'collection') return body.classList.contains('template-collection');
    if (pages === 'custom') {
      var handle = (window.location.pathname.split('/').filter(Boolean).pop() || '').toLowerCase();
      return customHandles.indexOf(handle) !== -1;
    }
    return true;
  }

  function frequencyAllows(frequency, freqDays, cookieName) {
    if (frequency === 'every_load') return true;
    if (frequency === 'session') {
      return sessionStorage.getItem(cookieName) !== '1';
    }
    if (frequency === 'days' || frequency === 'once') {
      var stored = getCookie(cookieName);
      return !stored;
    }
    return true;
  }

  function markSeen(frequency, freqDays, cookieName) {
    if (frequency === 'every_load') return;
    if (frequency === 'session') {
      sessionStorage.setItem(cookieName, '1');
      return;
    }
    if (frequency === 'days') {
      setCookie(cookieName, '1', freqDays);
      return;
    }
    if (frequency === 'once') {
      setCookie(cookieName, '1', 3650);
      return;
    }
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + value + '; expires=' + expires + '; path=/; SameSite=Lax';
  }
  function getCookie(name) {
    return document.cookie.split('; ').reduce(function (acc, part) {
      var idx = part.indexOf('=');
      if (part.substring(0, idx) === name) return part.substring(idx + 1);
      return acc;
    }, null);
  }

  function loadKlaviyoForm(root) {
    var formEl = root.querySelector('[data-klaviyo-form]');
    if (!formEl || formEl.dataset.loaded) return;
    formEl.dataset.loaded = 'true';
    // Klaviyo's onsite JS (loaded globally via theme.liquid) automatically
    // scans the DOM for elements with a class like "klaviyo-form-XXXXXX".
    // Since the popup starts hidden (display:none), Klaviyo may not have
    // picked it up on initial page load — nudge it to re-scan once visible.
    if (window._klOnsite && typeof window._klOnsite.push === 'function') {
      window._klOnsite.push(['openForm', formEl.className.split(' ')[1] || '']);
    }
    // Fallback: dispatch a resize/scan event some Klaviyo versions listen for
    window.dispatchEvent(new Event('resize'));
  }

  function initAll() {
    document.querySelectorAll('[data-popup]').forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
